<!--
 * @Author: zerui.yao
 * @Date: 2022-11-28 10:52:12
 * @LastEditors: zerui.yao
 * @LastEditTime: 2022-12-06 12:21:48
 * @FilePath: /fed-authority/src/layouts/HeaderAsideLayout/components/tools/Logo.vue
 * @Description: 
-->
<template>
  <div class="logo">
    <router-link :to="{ name: 'home' }">
      <!-- <img :src="company"
        alt="company"
        class="company-logo" /> -->
      <e2-svg v-if="showCompany" name="company" class="company-logo" />
      <a-divider v-if="showCompany" type="vertical" />
      <!-- <img :src="logo"
        alt="logo"
        class="site-logo" /> -->
      <!-- <e2-svg name="logo"
        class="site-logo" /> -->
      <span>ACS</span>
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
    <!-- <span style="font-weight:500;font-size: 18px;color: #333;margin-left: 58px">{{$t($route.meta.titleKey)}}</span> -->
  </div>
</template>

<script>
// import company from '@/assets/company.svg';
// import logo from '@/assets/site_logo.svg';

export default {
  name: 'Logo',
  components: {},
  data() {
    return {
      // company,
      // logo,
      showCompany: true
    };
  },
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
};
</script>
<style lang="less">
.logo {
  margin-left: 12px;
  .company-logo {
    height: 22px;
    width: 88px;
    position: relative;
    // top: -2px;
  }
  .site-logo {
    fill: @primary-color;
    height: 14px;
    display: inline-block;
    width: 35px;
    position: relative;
    // top: -2px;
  }
}
</style>
